$(document).ready(function () {
  $('.ingredient-heading').click(function () {
    var $heading = $(this);
    var $paragraph = $heading.next('.ingredient-paragraph');
    var $icon = $heading.find('.toggle-icon');
    $paragraph.slideToggle(300, function () {
      if ($paragraph.is(':visible')) {
        $icon.text('–');
        $heading.addClass('active');
      } else {
        $icon.text('+');
        $heading.removeClass('active');
      }
    });
  });
});





function copyCode() {
  const $codeSpan = $("#coupon-code");
  const $icon = $(".coupon-icon");
  const originalText = $codeSpan.text();
  navigator.clipboard.writeText(originalText).then(() => {
    $codeSpan.text("Code copied");
    $icon.hide();
    setTimeout(() => {
      $codeSpan.text(originalText);
      $icon.show();
    }, 1500);
  });
}

function setupScrollButtons() {
  const scrollContainer = document.querySelector('.complementary-products_all');
  const leftBtn = document.querySelector('.scroll-left');
  const rightBtn = document.querySelector('.scroll-right');

  if (!scrollContainer || !leftBtn || !rightBtn) {
    requestAnimationFrame(setupScrollButtons);
    return;
  }
  const scrollAmount = 300;
  leftBtn.addEventListener('click', () => {
    scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });

  rightBtn.addEventListener('click', () => {
    scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });
}

document.addEventListener('DOMContentLoaded', setupScrollButtons);


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.wt-rating').forEach(function (ratingWrapper) {
    const counter = ratingWrapper.querySelector('.wt-rating__counter');
    if (counter && counter.textContent.trim() === "(No reviews)") {
      ratingWrapper.style.display = "none";
    }
  });
});





$(document).on('click', '.custom_atc', function (e) {
  e.preventDefault();
  const vid = $(this).data('vid');
  const form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', '/cart/add');
  const input = document.createElement('input');
  input.setAttribute('type', 'hidden');
  input.setAttribute('name', 'id');
  input.setAttribute('value', vid);
  form.appendChild(input);
  document.body.appendChild(form);
  const productFormEl = document.querySelector('product-form');
  if (productFormEl) {
    const productFormInstance = productFormEl;
    productFormInstance.form = form;
    productFormInstance.onSubmitHandler({ preventDefault: () => {} });
  }
});




$(document).ready(function(){
  // var $activeBtn = $(".tabingbutton-sectioninner button.active");
  // if ($activeBtn.length) {
  //   var desktopImg = $activeBtn.data("desktop-img");
  //   var mobileImg = $activeBtn.data("mobile-img");
  //   if (!mobileImg || mobileImg.trim() === "") {
  //     mobileImg = desktopImg;
  //   }
  //   $(".custom-tabing-collection-d_img").attr("src", desktopImg);
  //   $(".custom-tabing-collection-m_img").attr("src", mobileImg);
  // }

  $(".tabingbutton-sectioninner button").on("click", function() {
    var desktopImg = $(this).data("desktop-img");
    var mobileImg = $(this).data("mobile-img");
    if (!mobileImg || mobileImg.trim() === "") {
      mobileImg = desktopImg;
    }
    $(".custom-tabing-collection-d_img").attr("src", desktopImg);
    $(".custom-tabing-collection-m_img").attr("src", mobileImg); 
  });
});



if($(window).width() < 767) { 
        $("button.tab-btn").click(function(){
          $(".slidersection-text").slick({
          dots: true,
          infinite: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false 
        });
      })

  
} else {
   // change functionality for larger screens
}


$(".tabingbutton-sectioninner button").click(function(){
        $(".tabingbutton-sectioninner button").removeClass("active");
        $(this).addClass("active");
        var dataText = $(this).data("text");
        $(".wt-featured-collection slideshow-section").hide();
        $(`slideshow-section[data-value="${dataText}"]`).show();
      })


      $(".flip-card .flip-front img").click(function(){
        $(".flip-card").removeClass("active");
        $(this).closest(".flip-card").addClass("active");
      });

      $(".card_contentsec span").click(function(){
        //alert("Hello");  
        $('.card_contentsec span').css('font-weight', '100');
        var dataValue = $(this).data("value")
        $(".imagesection-search").hide();
        $(this).parents(".flip-card").find(".imagesection-search").show();
        $(`.contentsearch-section`).hide();
        $(`[data-text="${dataValue}"]`).show();
        $(this).css('font-weight', '600');
      })

      $(".closebtn_card").click(function(){
        $(".card_contentsec span").removeClass("active");
        $(".imagesection-search").hide();
        $(`.contentsearch-section`).hide();
        $(this).closest(".flip-card").prevAll(".productsec_img:first").css("z-index", 1);
        $('.card_contentsec span').css('font-weight', '100');
      })

      $('.RightSection .card_contentsec span').click(function(){
         $(this).closest(".flip-card").prevAll(".productsec_img:first").css("z-index", 0);
      })


       // Init on page load
      const rellax = new Rellax('.parllax', {
        center: true,     // Centers the scroll effect
        round: true,      // Rounds values (set false for smoother)
        vertical: true,
        horizontal: false
      });


$(".closebtn-ing").click(function(){
  $(".popupingredients-section").hide();
  $(".ingredients_btn").removeClass("active");
})

$(".ingredients_btn").click(function(){
  $(".popupingredients-section").show();
  $(this).addClass("active");
})

$(document).ready(function () {
  const $readMoreBtn = $(".read-more-btn");
  const $readLessBtn = $(".read-less-btn");
  const $content = $(".ingredients-content");

  if ($readMoreBtn.length && $readLessBtn.length && $content.length) {
    $readMoreBtn.on("click", function () {
      $content.addClass("expanded");
      $readMoreBtn.hide();
      $readLessBtn.show();
    });

    $readLessBtn.on("click", function () {
      $content.removeClass("expanded");
      $readLessBtn.hide();
      $readMoreBtn.show();
    });
  }
});


document.addEventListener("DOMContentLoaded", function() {
  // Find all Add to Cart buttons
  const addToCartButtons = document.querySelectorAll('button[name="add"], button[type="submit"][name="add"]');

  // 
    addToCartButtons.forEach(button => {
    button.addEventListener("click", function() {
      // Call your tracking event
      if (typeof window !== "undefined" && window?.auditzy) {
        window?.auditzy?._queue.push({
          event: 'conversion_track', // don't change this
          action: 'add_to_cart', // don't change this
        });
        // console.log("Auditzy: Add to Cart event sent ✅");
      }
    });
  });
});

//  checkout-button Event 
document.addEventListener('DOMContentLoaded', function() {
  const checkoutBtn = document.querySelector('#yt-checkout-button');

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      console.log("Begin Payment event triggered");

      if (typeof window !== "undefined" && window?.auditzy) {
        window.auditzy._queue.push({
          event: 'conversion_track', // don't change this
          action: 'begin_payment', // don't change this
        });
        // console.log("Auditzy: Add to Cart event sent ✅");
      }
    });
  }
});